import * as types from '../mutation-types'
import {GetAccountsWithBalances} from '../data-reformer.js'

const state = {
	accounts_tree: [],
	accounts: [],
	main_box:{}
};
const actions = {
	fetchTree({ commit }) {
		return window.axios.get('Accounts/Tree'
		).then(response => {
			commit(types.STORE_ACCOUNTS_TREE, response.data);
			return response.data;
		});
	},

	fetchAll({ commit }, { financialFileId } = {}) {
		let configs = undefined;
		if (financialFileId){
			configs = { headers: { ['X-FinancialFileId']: financialFileId } }
		}
		return window.axios.get('Accounts', configs).then(response => {
			commit(types.STORE_ACCOUNTS, response.data);
			return response.data;
		});
	},

	fetch(vuexContext, { id }) {
		return window.axios.get(`Accounts/${id}`).then(response => {
			return response.data;
		});
	},

	create(vuexContext, account) {
		return window.axios.post('Accounts', {
				name: account.name,
				inner_accounting_no: account.inner_accounting_no,
				type: account.type,
				final_type: account.final_type,
				max_credit_amount: account.max_credit_amount,
				max_debit_amount: account.max_debit_amount,
				is_debt_forbidden: account.is_debt_forbidden,
				notes: account.notes,
				parent_account_id: account.parent_account_id,
				custom_statement_ids: account.custom_statement_ids,
				contact_info: account.contact_info
		}).then(response => {
			return response.data;
		});
	},

	update(vuexContext, account) {
		return window.axios.put(`Accounts/${account.id}`, {
			id: account.id,
			name: account.name,
			inner_accounting_no: account.inner_accounting_no,
			type: account.type,
			final_type: account.final_type,
			max_credit_amount: account.max_credit_amount,
			max_debit_amount: account.max_debit_amount,
			is_debt_forbidden: account.is_debt_forbidden,
			notes: account.notes,
			parent_account_id: account.parent_account_id,
			custom_statement_ids: account.custom_statement_ids,
			contact_info: account.contact_info
		}).then( response => {
			return response.data;
		});
	},

	delete(vuexContext, { id }) {
		return window.axios.delete(`Accounts/${id}`);
	},
	getMainBox({ commit }) {
		return window.axios.get(`Accounts/MainBox`).then(response => {
			commit(types.STORE_MAIN_BOX, response.data);
			return response.data;
		});
	},
	
	changeMainBox({ commit }, newBoxAccountId) {
		const config = { headers: {'Content-Type': 'application/json'} }
		return window.axios.put(`Accounts/ChangeMainBox`,newBoxAccountId, config).then(response => {
			commit(types.STORE_MAIN_BOX, response.data);
			return response.data;
		});
	},

	createDefaultFinancialFileAccount(vuexContext, { type, name, inner_no, parent_id, final_type }) { 
		return window.axios.post('Accounts/createDefaultAccount', {
			type, name, inner_no, parent_id, final_type
		})
	},

	getSuggestNameForEndingAccountingPeriod(vuexContext, { type }) { 
		return window.axios.get(`Accounts/SuggestNameForEndingAccountingPeriod/${type}`)
		.then((response) => {
			return response.data;
		})
	},

	GenerateNewAccountNo(vuexContext, id){
		return window.axios.get(`Accounts/${id}/GenerateNewAccountNo`).then(response => {
			return response.data;
		});
	}
};

const mutations = {
	[types.STORE_ACCOUNTS_TREE](state, accounts_tree) {
		state.accounts_tree = accounts_tree;
	},

	[types.STORE_ACCOUNTS](state, accounts) {
		state.accounts = accounts;
	},

	[types.STORE_MAIN_BOX](state, main_box) {
		state.main_box = main_box;
	},
};

const getters = {
	getById: state => id => state.accounts_tree.find(t => t.id === id),
	getAccountsWithBalances: state => state.accounts.length ? GetAccountsWithBalances(state.accounts) : state.accounts
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};

